import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DesignEditorPrimaryControls } from '../../../DesignEditor/components/DesignEditorControls';
import { CardDesignerLayoutControlsButton } from './components/CardDesignerLayoutControls';
import { CONTROL_SECTION } from '../../helpers';
import { CardDesignerBackgroundControlsButton } from './components/CardDesignerBackgroundControls';
import { CardDesignerForegroundControlsButton } from './components/CardDesignerForegroundControls';
import { CardDesignerLogoControlsButton } from './components/CardDesignerLogoControls';
import { CardDesignerPhotoControlsButton } from './components/CardDesignerPhotoControls';
import { CardDesignerTextControlsButton } from './components/CardDesignerTextControls';
import { CardDesignerLayerControlsButton } from './components/CardDesignerLayerControls';
import { CardDesignerGridControlsButton } from './components/CardDesignerGridControls';

const propTypes = {
  className: PropTypes.string,
  onControlSelect: PropTypes.func.isRequired,
  activeControlSection: PropTypes.string,
  gridEnabled: PropTypes.bool,
  setGridEnabled: PropTypes.func,
};

const CardDesignerMainControlPanel = ({
  className,
  onControlSelect,
  activeControlSection,
  gridEnabled,
  setGridEnabled,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControls className={classes}>
      <CardDesignerLayoutControlsButton
        active={activeControlSection === CONTROL_SECTION.LAYOUT}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.LAYOUT);
        }}
      />
      <CardDesignerLogoControlsButton
        active={activeControlSection === CONTROL_SECTION.LOGO}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.LOGO);
        }}
      />
      <CardDesignerBackgroundControlsButton
        active={activeControlSection === CONTROL_SECTION.BACKGROUND}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.BACKGROUND);
        }}
      />
      <CardDesignerForegroundControlsButton
        active={activeControlSection === CONTROL_SECTION.FOREGROUND}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.FOREGROUND);
        }}
      />
      <CardDesignerPhotoControlsButton
        active={activeControlSection === CONTROL_SECTION.PHOTOS}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.PHOTOS);
        }}
      />
      <CardDesignerTextControlsButton
        active={activeControlSection === CONTROL_SECTION.TEXTS}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.TEXTS);
        }}
      />
      <CardDesignerLayerControlsButton
        active={activeControlSection === CONTROL_SECTION.LAYERS}
        onClick={() => {
          onControlSelect(CONTROL_SECTION.LAYERS);
        }}
      />
      <CardDesignerGridControlsButton
        active={gridEnabled}
        onClick={() => {
          setGridEnabled(prev => !prev);
        }}
        className="card-designer-grid-controls-btn"
      />
    </DesignEditorPrimaryControls>
  );
};

CardDesignerMainControlPanel.propTypes = propTypes;

export default CardDesignerMainControlPanel;
